module.exports = __webpack_public_path__ + "static/gun-d3529ee974f99e5e22d05369abe359af.png";